import { faqData } from '@/mocks/homeData';

export default function FaqSection() {
  return (
    <section id="faq" className="py-16 md:py-20 px-4 md:px-6 bg-background-50">
      <div className="max-w-[800px] mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">
            常见问题
          </h2>
          <p className="mt-3 text-foreground-600 text-sm md:text-base max-w-[500px] mx-auto">
            快速找到答案，解决你的疑问
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-5">
          {faqData.map((item) => (
            <div
              key={item.id}
              className="bg-background-100 rounded-lg border border-background-200/60 p-5 md:p-6"
            >
              <div className="flex items-start gap-3">
                <div className="flex-shrink-0 w-6 h-6 flex items-center justify-center rounded-full bg-primary-500 text-background-50 mt-0.5">
                  <i className="ri-question-mark text-xs"></i>
                </div>
                <div className="flex-1 min-w-0">
                  <h3 className="text-sm md:text-base font-semibold text-foreground-900">
                    {item.question}
                  </h3>
                  <p className="mt-2.5 text-sm text-foreground-600 leading-relaxed">
                    {item.answer}
                  </p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}